<template>
<div class="chapter">
<div class="inner_page">
<a id="pFrontCover"></a><a id="pFrontFlap"></a><a id="pi"></a><a id="pii"></a><a id="piii"></a>
<blockquote class="sink">
<p class="center "><em>With gratitude to Rebecca,</em><br/>
<em>And also to the wonderful Georgette Heyer</em></p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?872e4406